import React, { useState } from 'react';
import Layout from 'components/layout';
import { Grid } from '@material-ui/core';
import { breakpoint } from 'utils/mediaQueries';
import styled from 'styled-components';
import LinkBlocks from 'components/LinkBlock/LinkBlocks';
import LinkBlockBackground from 'components/pages/Solution/Marketing/LinkBlockBackground';
import ProblematicBlocks from 'components/pages/ClientCase/ProblematicBlocks/ProblematicBlocks';
import IntroBlocks from 'components/pages/ClientCase/IntroBlocks';
import InfoBlocks from 'components/pages/ClientCase/InfoBlocks/InfoBlocks';
import KeypointsBlocks from 'components/pages/ClientCase/Keypoints/KeypointsBlocks';
import _ from 'lodash';
import fr from 'locales/fr.json';
import en from 'locales/en.json';
import es from 'locales/es.json';
import ResourcesBlocks from 'components/pages/Webinars/ResourcesBlocks';

const LinkGrid = styled(Grid)`
  margin-top: -4rem;
  position: relative;
  padding-top: 10rem;
  padding-bottom: 4rem;
  background-position: top;
  ${breakpoint.down('lg')`
  padding-top: 6rem;padding-bottom: 2rem;margin-top: 0;`}
  ${breakpoint.down('md')`
  padding-bottom: 4rem;`}
  ${breakpoint.down('sm')`padding-top:0;padding-bottom: 6rem;`};
`;
const ClientCasePage = props => {
  const getActiveChip = () => {
    const chipNames = props.data.dataBlockIntroBody.nodes.map(
      ({ frontmatter }) => frontmatter.useCases
    );
    const param = props.location.search.substring(1);
    if (chipNames.includes(param)) {
      return param;
    } else {
      return 'banking';
    }
  };

  const [activeChip, setActiveChip] = useState(getActiveChip());
  const getLocale = () => {
    switch (props.pageContext.langKey) {
      case 'fr':
        return fr;
      case 'en':
        return en;
      case 'es':
        return es;
      default:
        return en;
    }
  };
  const locale = getLocale();
  const seo = {
    ...props.seo,
    title: `${props.seo.title} - ${locale.useCases[activeChip]}`,
  };
  function getActiveCase(cases) {
    setActiveChip(cases);
  }
  const allData = {
    data: props.data.allData.group,
  };
  const allImages = {
    images: props.data.allImages.nodes,
  };
  const filterData = allData.data.map(data => data.nodes);
  const relevantArray = _.find(
    filterData,
    array => array[0].frontmatter.useCases === activeChip
  );
  const getQuote = _.find(
    relevantArray,
    quote => quote.frontmatter.component === 'title'
  );
  const getInfos = _.find(relevantArray, info => info.frontmatter.infos);

  const getKeypoints = _.filter(
    relevantArray,
    keypoint => keypoint.frontmatter.blockType === 'keypointsBlock'
  );
  const introBlocksData = {
    title: props.data.dataBlockIntroTitle,
    chips: props.data.dataBlockIntroBody,
  };
  const linkBlocksData = {
    markdownContent: props.data.dataBlockLinkBody,
  };
  const problematicBlocksData = {
    title: getQuote,
    images: [
      _.find(
        allImages.images,
        image => image.base === getQuote.frontmatter.relatedImageLeft
      ),
      _.find(
        allImages.images,
        image => image.base === getQuote.frontmatter.relatedImageRight
      ),
    ],
  };
  const infoBlocksData = {
    markdownContent: getInfos.frontmatter.infos,
  };
  const keypointsBlockdata = {
    markdownContent: getKeypoints,
  };
  const testimonialData = {
    markdownContent: props.data?.dataTestimonialClientCaseBlock?.nodes,
    images: props.data?.imagesTestimonialClientCaseBlock?.nodes,
  };
  return (
    <Layout location={props.location} seo={seo}>
      <IntroBlocks
        data={introBlocksData}
        lang={props.pageContext.langKey}
        callback={cases => getActiveCase(cases)}
        activeChip={activeChip}
      />
      <ProblematicBlocks data={problematicBlocksData} />
      <InfoBlocks data={infoBlocksData} />
      <KeypointsBlocks
        data={keypointsBlockdata}
        testimonialData={testimonialData}
        lang={props.pageContext.langKey}
        clientCase={activeChip}
      />
      <ResourcesBlocks lang={props.pageContext.langKey} />
      <LinkGrid>
        <LinkBlocks
          data={linkBlocksData.markdownContent.nodes}
          lang={props.pageContext.langKey}
        />
        <LinkBlockBackground />
      </LinkGrid>
    </Layout>
  );
};
export default ClientCasePage;
